import React from 'react';

import NationalReports from '../components/NationalReports';

export default class NationalReportsPage extends React.PureComponent {
  render() {
    const query = this.props.location.query;

    return (
      <div style={{ minHeight: '600px' }}>
        <h2>
          National reports<br />
        </h2>
        <p>
          National reports from 2002 to current year 
        </p>
        <NationalReports query={ query }/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/NationalReports.js